import { Typography } from "@/components/atoms";

export const WelcomeHeader = () => (
  <div className="text-center">
    <Typography variant="h2" className="mb-1 text-neutral-dark-gray">
      Welcome to RideMinder 🎉
    </Typography>
    <Typography variant="paragraph" className="mb-3 text-neutral-dark-gray">
      This web portal is where you manage your account, billing, and payments.
    </Typography>
    <Typography variant="paragraph" className="text-neutral-dark-gray">
      To run jobs day-to-day — including accepting bookings, managing clients, and completing trips — you&apos;ll use the RideMinder Driver
      App on your mobile device.
    </Typography>
  </div>
);
